import React from 'react';
import styles from './AttendanceGraph.module.css';

interface AttendanceGraphProps {
  data: any;
}

const AttendanceGraph: React.FC<AttendanceGraphProps> = ({ data }) => {
  if (!data || !data.course) return null
  const sessions = data.course.sessions;

  // Function to calculate the percentage of each attendance status
  const getStatusPercentages = (attendance: any[]) => {
    const total = attendance.length;
    if (total === 0) return { present: 0, absent: 0, pending: 0, other: 0 };

    const present = attendance.filter(a => a.status === 'PRESENT').length;
    const absent = attendance.filter(a => a.status === 'ABSENT').length;
    const pending = attendance.filter(a => a.status === 'PENDING').length;
    const other = attendance.filter(a => !['PRESENT', 'ABSENT', 'PENDING'].includes(a.status)).length;

    return {
      present: (present / total) * 100,
      absent: (absent / total) * 100,
      pending: (pending / total) * 100,
      other: (other / total) * 100,
    };
  };

  return (
    <div className={styles.chart}>
      {sessions.map((session: any) => {
        const { present, other, absent, pending } = getStatusPercentages(session.attendance.filter((a: any) => !a.isTeacher));
        return (
          <div className={styles.session} key={session.id}>
            <div className={styles.column}>
              <div className={`${styles.segment} ${styles.pending}`} style={{ height: `${pending}%` }}></div>
              <div className={`${styles.segment} ${styles.absent}`} style={{ height: `${absent}%` }}></div>
              <div className={`${styles.segment} ${styles.other}`} style={{ height: `${other}%` }}></div>
              <div className={`${styles.segment} ${styles.present}`} style={{ height: `${present}%` }}></div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export { AttendanceGraph };
